<div class="planning-box" appClickOutside [isInsideOverlay]="isInsideOverlay" (clickOutside)="closePanel()">
    <div class="planning-box__header">
        <nav>
            <button [class.btn-active]="defaultView" (click)="handleDefaultViewSwitcher(true)">
                Plan a trip
            </button>
            <button [class.btn-active]="!defaultView" (click)="handleDefaultViewSwitcher(false)">
                Explore city
            </button>
        </nav>
    </div>

    <div class="planning-box__content">
        <div class="planning-box__inputs">
            @if (defaultView) {
                <div matAutocompleteOrigin #startOrigin="matAutocompleteOrigin" class="input-box">
                    <span>Start at:</span>
                    <input
                            type="text"
                            placeholder="City, Country"
                            [value]="trip().startingLabel"
                            [matAutocomplete]="autoStartAt"
                            [matAutocompleteConnectedTo]="startOrigin"
                            (input)="inputChanged($event, searchQueryStartInChanged)"
                            (click)="cleanSelection('starting', trip().startingLocationId);"
                            (focusin)="isInsideOverlay = true"
                            (focusout)="inputFocusOut(autoStartAt, 'starting')"
                    />
                    <mat-autocomplete
                        #autoStartAt="matAutocomplete"
                        [displayWith]="displayWith"
                        (optionSelected)="optionSelected($event, 'starting')"
                    >
                        @if (startInDestinationOptions$ | async; as destinations) {
                            <div class="f-col full-height">
                                <div class="autocomplete-list">
                                    @if (destinations.length) {
                                        @for (destination of destinations; track destination) {
                                            @if (destination && destination?.category) {
                                                <mat-option class="error-option">
                                                    We currently don’t support this destination
                                                </mat-option>
                                            } @else {
                                                <mat-option [value]="destination">
                                                    {{ destination.label }}
                                                </mat-option>
                                            }
                                        }
                                    }
                                </div>
                            </div>
                        }
                    </mat-autocomplete>
                </div>
                <span class="arrow">
                  <svg width="41" height="16" viewBox="0 0 41 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40.7071 8.70711C41.0976 8.31658 41.0976 7.68342 40.7071 7.29289L34.3431 0.928932C33.9526 0.538408 33.3195 0.538408 32.9289 0.928932C32.5384 1.31946 32.5384 1.95262 32.9289 2.34315L38.5858 8L32.9289 13.6569C32.5384 14.0474 32.5384 14.6805 32.9289 15.0711C33.3195 15.4616 33.9526 15.4616 34.3431 15.0711L40.7071 8.70711ZM0 9H40V7H0V9Z"
                          fill="#375C7F"/>
                  </svg>
                </span>
                <div matAutocompleteOrigin #endOrigin="matAutocompleteOrigin" class="input-box">
                    <span>End at:</span>
                    <input
                            id="end-in-input"
                            #endInput
                            type="text"
                            placeholder="City, Country"
                            [value]="trip().endingLabel"
                            [matAutocomplete]="autoEndAt"
                            [matAutocompleteConnectedTo]="endOrigin"
                            (input)="inputChanged($event, searchQueryEndInChanged)"
                            (focusin)="isInsideOverlay = true"
                            (focusout)="inputFocusOut(autoEndAt, 'ending')"
                    />
                    <mat-autocomplete
                        #autoEndAt="matAutocomplete"
                        [displayWith]="displayWith"
                        (optionSelected)="optionSelected($event, 'ending'); autoGoToNextField()"
                    >
                        @if (endInDestinationOptions$ | async; as destinations) {
                            <div class="f-col full-height">
                                <div class="autocomplete-list">
                                    @if (destinations.length) {
                                        @for (destination of destinations; track destination) {
                                            @if (destination && destination?.category) {
                                                <mat-option class="error-option">
                                                    We currently don’t support this destination
                                                </mat-option>
                                            } @else {
                                                <mat-option [value]="destination">
                                                    {{ destination.label }}
                                                </mat-option>
                                            }
                                        }
                                    }
                                </div>
                            </div>
                        }
                    </mat-autocomplete>
                </div>
            } @else {
                <div matAutocompleteOrigin #startOrigin="matAutocompleteOrigin" class="input-box">
                    <span>City:</span>
                    <input
                            type="text"
                            placeholder="Type city name"
                            [value]="trip().cityInfo?.label"
                            [matAutocomplete]="autoStartAt"
                            [matAutocompleteConnectedTo]="startOrigin"
                            (input)="inputChanged($event, searchQueryStartInChanged)"
                            (focusin)="isInsideOverlay = true"
                            (focusout)="isInsideOverlay = false"
                    />
                    <mat-autocomplete
                        #autoStartAt="matAutocomplete"
                        [displayWith]="displayWith"
                        (optionSelected)="exploreCitySelected($event); autoGoToNextField()"
                    >
                        @if (startInDestinationOptions$ | async; as destinations) {
                            <div class="f-col full-height">
                                <div class="autocomplete-list">
                                    @if (destinations.length) {
                                        @for (destination of destinations; track destination) {
                                            @if (destination && destination?.category) {
                                                <mat-option class="error-option">
                                                    We currently don’t support this destination
                                                </mat-option>
                                            } @else if (destination.url) {
                                                <mat-option [value]="destination">
                                                    {{ destination.label }}
                                                </mat-option>
                                            }
                                        }
                                    }
                                </div>
                            </div>
                        }
                    </mat-autocomplete>
                </div>
            }
        </div>
    </div>
    <span data-attr="sp-sign-up-ls"></span>
</div>
